<button mat-button
        mat-stroked-button
        color="accent"
        class="contract-button"
        (click)="handleClick()">
  {{ (isMobile$ | async) ? 'Договір' : 'Укласти договір' }}
</button>
